import keys from '@/config/keys'
import { Permit2 } from './Permit2'

export class SpendChecker {
  static async checkSpend(token, wallet) {
    if (!token) {
      throw new Error('Must provide a token to check spend allowance')
    }
    if (!wallet) {
      throw new Error('Must provide a wallet to check spend allowance')
    }

    return await Permit2.checkSpendAllowance(
      token.address ? token.address : token,
      wallet,
    )
  }

  static async increaseSpend(token, wallet, amount) {
    if (!token) {
      throw new Error('Must provide a token to check spend allowance')
    }
    if (!wallet) {
      throw new Error('Must provide a wallet to check spend allowance')
    }

    return await Permit2.increaseSpendAllowance(
      token.address ? token.address : token,
      wallet,
      amount,
    )
  }

  static async getSignature(props) {
    const { prevNonce, token, wallet, amount, expiration } = props
    if (!token) {
      throw new Error('Must provide a token to create signture')
    }
    if (!wallet) {
      throw new Error('Must provide a wallet to create signature')
    }
    if (!amount || BigInt(amount) === BigInt(0)) {
      throw new Error('Missing amount for signature')
    }
    if (!expiration) {
      throw new Error('Must provide expiration for signature')
    }
    const spender = keys.crypto.TRIPSHA_WALLET_ADDRESS
    if (!spender) {
      throw new Error('Must have TRIPSHA_WALLET_ADDRESS in env')
    }

    return await Permit2.signTransferFrom({
      prevNonce,
      wallet,
      spender,
      token,
      amount,
      expiration,
    })
  }

  static async transferFrom(props) {
    const { nonce, token, deadline, amount, signature, wallet } = props

    return await Permit2.transferFrom({
      to: keys.crypto.TRIPSHA_WALLET,
      nonce,
      token,
      deadline,
      amount,
      signature,
      wallet,
    })
  }
}
